import { getFirebaseServices } from "@/lib/firebase/client";

export function useFirebase() {
  const services = getFirebaseServices();
  if (!services) {
    throw new Error("Firebase is not configured.");
  }
  return services;
}
